<template>
    <div class="card">
        <div class="tyoeStatus">
            <span class="type">{{ type }}</span>
            <span v-if="status === 'Open Registration'" class="status">{{ status }}</span>
            <span v-else class="status-not-active">{{ status }}</span>
        </div>
        <h2 class="card-title mt-4">{{ title }}</h2>
        <p class="card-content">{{ content }}</p>
        <div style="display: flex; justify-content: start; align-items: center; width: 90%; margin-bottom: 20px;">
            <Calendar />
            <p class="start-end-date">{{ start_date }} - {{ end_date }}</p>
        </div>
        <div style="display: flex; justify-content: start; align-items: center; width: 90%; margin-bottom: 20px;">
            <Clock />
            <p class="start-end-date">{{ time }}</p>
        </div>
        <div style="display: flex ; justify-content: start; align-items: center; width: 90%; margin-bottom: 20px;">
            <MapPin />
            <p class="start-end-date">{{ venue }}</p>
        </div>
        <div style="display: flex ; justify-content: start; align-items: center; width: 90%; margin-bottom: 20px;">
            <UsersRound />
            <p class="start-end-date">{{ users }} {{ capacity_type }}</p>
        </div>

        <button @click.stop="handleRegisterClick">Register</button>
    </div>
</template>

<script setup>
import { Calendar, Clock, MapPin, UsersRound } from "lucide-vue-next";
/* eslint-disable */
defineProps({
    title: {
        type: String,
        required: true
    },
    content: {
        type: String,
        default: ""
    },
    start_date: {
        type: String,
        default: ""
    },
    end_date: {
        type: String,
        default: ""
    },
    time: {
        type: String,
        default: ""
    },
    venue: {
        type: String,
        default: ""
    },
    users: {
        type: String,
        default: ""
    },
    capacity_type: {
        type: String,
        default: ""
    },
    type: {
        type: String,
        default: ""
    },
    status: {
        type: String,
        default: ""
    },
    event_status: {
        type: String,
        default: ""
    },
    icon: {
        type: Object,
        default: null
    }
});

const emit = defineEmits(["cardClick", "registerClick"]);

function handleClick() {
  emit("cardClick");
}

function handleRegisterClick() {
  emit("registerClick");
}
</script>

<style lang="scss" scoped>
.card {
    height: 443px;
    border-radius: 24px;
    overflow: hidden;
    border: 1px solid #DCE3E7;
    //background-image: url("../../assets/images/cardBg.png");
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 380px;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding: 20px 3rem;
    background: #072a08;
    color: #fff;

    button {
        width: 100%;
        background-color: #ED4E24;
        color: white;
        padding: 10px;
        border-radius: 30px;
        border: none;
    }

    .tyoeStatus {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .type {
            background-color: #fff;
            color: #000;
            border: 1px solid #0000001F;
            padding: 5px 10px;
            font-size: 14px;
            font-weight: 500;
            border-radius: 30px;
        }

        .status-not-active {
            background-color: #F51D09;
            color: #FFF;
            border: 1px solid #fff;
            padding: 5px 10px 5px 10px;
            font-size: 13px;
            font-weight: 500;
            border-radius: 30px;
            //width: 100%;
        }

        .status {
            background-color: #F51D09;
            color: #FFF;
            padding: 5px 10px;
            font-size: 14px;
            font-weight: 500;
            border-radius: 30px; 
        }
    }
}

.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    width: 74px;
    height: 74px;
    padding: 8px;
    border-radius: 50%;
    border: 1px solid #DCE3E7;

    .card-image {
        background: linear-gradient(to bottom, #ED4E24, #F97316);
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
    }
}

.card-body {
    padding: 16px;
}

.card-title {
    font-size: 18px;
    color: #fff;
    font-weight: 500;
    margin: 10px 0;
    font-family: "Open Runde", sans-serif;
    text-align: center;
}

.card-content {
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    font-family: "Open Runde", sans-serif;
    text-align: center;
}
.start-end-date{
    margin: 0%; 
    padding: 0% 10px;
    font-size: 15px;
}

@media (max-width: 768px) {
    .card {
        width: 100%;
    }
    .card-title {
        font-size: 18px;
    }

    .start-end-date{
    margin: 0%; 
    padding: 0% 10px;
    font-size: 12px;
}
}
</style>
